import { match as containersTab } from "../../../src/params/containersTab.ts";
import { match as dash } from "../../../src/params/dash.ts";
import { match as likelyNotebookId } from "../../../src/params/likelyNotebookId.ts";
import { match as workspace } from "../../../src/params/workspace.ts";

export const matchers = { containersTab, dash, likelyNotebookId, workspace };